import * as React from 'react'
import { SafeAreaView, Text, View, Image, PixelRatio } from 'react-native'
import styled from '@theme/styled-components'

import useBreakpoint from '@utils/useBreakpoints'
import useI18n from '@i18n/useI18n'

const BASE_LINE_FONT_SIZE = 170
const BASE_LINE_LINE_HEIGHT = 206
const NUMBER_OF_BASE_LINE = 3
const SCREEN_BASE_FOR_SCALE = 1440

interface Props {
  children: JSX.Element
}

const LoginWebLayout = ({ children }: Props) => {
  const i18n = useI18n()

  const [windowSize] = useBreakpoint()

  const xScale = windowSize.width / SCREEN_BASE_FOR_SCALE

  const normailzeFont = () => {
    const newSize = BASE_LINE_FONT_SIZE * xScale
    return Math.round(PixelRatio.roundToNearestPixel(newSize))
  }

  const normalizeLineHieght = () => {
    const newSize = (normailzeFont() * BASE_LINE_LINE_HEIGHT) / BASE_LINE_LINE_HEIGHT
    return Math.round(PixelRatio.roundToNearestPixel(newSize))
  }

  const normalizeTop = (position: number) => {
    const lineHeight = normalizeLineHieght()
    const blankHeight = windowSize.height - NUMBER_OF_BASE_LINE * lineHeight
    const newSize = blankHeight / 2 + position * lineHeight * 0.75
    return Math.round(PixelRatio.roundToNearestPixel(newSize))
  }

  return (
    <MainContainer>
      <LeftView>
        <Logo source={require('@assets/logo_viparis.png')} />

        <BaseLine fontSize={normailzeFont()} lineHeight={normalizeLineHieght()} top={normalizeTop(0)}>
          {i18n.t('screens.login.baseLine1')}
        </BaseLine>
        <BaseLine fontSize={normailzeFont()} lineHeight={normalizeLineHieght()} top={normalizeTop(1)} left="56%">
          {i18n.t('screens.login.baseLine2')}
        </BaseLine>
        <BaseLine fontSize={normailzeFont()} lineHeight={normalizeLineHieght()} top={normalizeTop(2)} left="10%">
          {i18n.t('screens.login.baseLine3')}
        </BaseLine>
        <Picture source={require('@assets/images/login/connexion_background.png')} />
      </LeftView>

      <RightView>{children}</RightView>
    </MainContainer>
  )
}

const LoginMobileLayout = ({ children }: Props) => {
  const [{ height, width }] = useBreakpoint()

  return (
    <MainContainer>
      <Picture source={require('@assets/images/login/connexion_background.png')} />
      <DrawerContainer windowHeight={height} windowWidth={width}>
        {children}
      </DrawerContainer>
    </MainContainer>
  )
}

const LoginLayout = (props: Props) => {
  const [, bp] = useBreakpoint()
  const isPhone = bp === 'phone'

  return isPhone ? <LoginMobileLayout {...props} /> : <LoginWebLayout {...props} />
}

export default LoginLayout

const MainContainer = styled(SafeAreaView)`
  flex: 1;
  flex-direction: row;
  justify-content: center;
`
const RightView = styled(View)`
  flex: 1;
`
const LeftView = styled(View)`
  flex: 1;
  justify-content: center;
  overflow: hidden;
`
const Picture = styled(Image)`
  background-color: ${(props) => props.theme.colors.primary};
  flex: 1;
  z-index: -1;
`
const Logo = styled(Image)`
  width: 150px;
  height: 40px;
  left: 48px;
  top: 48px;
  position: absolute;
  z-index: 1;
`
const BaseLine = styled(Text)<{ top?: number; left?: string; fontSize?: number; lineHeight: number }>`
  ${(props) => props.theme.fonts.LoginTitle};
  font-size: ${(props) => props.fontSize}px;
  line-height: ${(props) => props.lineHeight}px;
  color: white;
  position: absolute;
  z-index: 1;
  flex: 1;
  align-self: center;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
`
const DrawerContainer = styled(View)<{ windowHeight: number; windowWidth: number }>`
  position: absolute;
  z-index: 1;
  left: 0;
  bottom: 0;
  width: ${(props) => props.windowWidth}px;
  height: ${(props) => props.windowHeight - 96}px;
  background-color: ${(props) => props.theme.colors.background};
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  ${(props) => props.theme.constants.shadow};
`
